<template>
  <div class="wrapper d-flex flex-column vh-100">
    <div class="main_area d-flex">
      <main class="main_inner flex-grow-1 mt-0">
        <div class="comingsoon_area">
          <div class="comingsoon_inner d-grid align-items-center justify-content-center">
            <div class="comingsoon_img m-auto">
              <img class="img_comingsoon d-block mw-100" :src="img_comingsoon" height="140" alt="">
              <div class="d-none d-xl-block" :class="{'light-blue-text': $store.getters.brand.theme === 'theme3'}">
                <button class="btn btn_goback d-flex align-items-center" @click="$router.push({'name': 'HomePage'})">
                  <i class="icon-arrow_back" />
                  <span>{{ $t('Bao.return_back') + $t('Bao.home') }}</span>
                </button>
              </div>
            </div>
            <img class="img_comingsoon_banner mw-100" :src="img_comingsoon_banner" alt="">
            <div class="d-xl-none" :class="{'light-blue-text': $store.getters.brand.theme === 'theme3'}">
              <button class="btn btn_goback d-flex align-items-center m-auto" @click="$router.push({'name': 'HomePage'})">
                <i class="icon-arrow_back" />
                <span>{{ $t('Bao.return_back') + $t('Bao.home') }}</span>
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { getImage } from '@/api/brand'
export default {
  name: 'ComingSoon',
  data() {
    return {
      img_comingsoon: null,
      img_comingsoon_banner: null
    }
  },
  created() {
    getImage({
      'group_code': 'img_comingsoon'
    }).then(response => {
      this.img_comingsoon = response.data.data !== undefined ? response.data.data[0].image : ''
    }).catch((error) => {
      console.log(error)
    })

    getImage({
      'group_code': 'img_comingsoon_banner'
    }).then(response => {
      this.img_comingsoon_banner = response.data.data !== undefined ? response.data.data[0].image : ''
    }).catch((error) => {
      console.log(error)
    })
  }
}
</script>

<style>
.comingsoon_area .light-blue-text .btn_goback {
  color: #31D9E3;
  border: 1px solid #31D9E3;
}
</style>
